import React from 'react';
import { useSelector } from 'react-redux';
import { namespace } from '../model';
import { formatNumber, multiplyFloor } from '../../common/tools';

export default (props) => {
  const {
    currency,
    coin,
    value,
    showType = 1,
    defaultValue,
    className,
    amountClassName,
    currencyClassName,
    hideLegalCurrency,
    needShowEquelFlag = true,
  } = props;

  const { prices } = useSelector((state) => state[namespace]);
  const rate = prices[coin];
  if (!rate || value === null) {
    return <span>{defaultValue}</span>;
  }
  let target = formatNumber(multiplyFloor(rate, value, 2), 2);
  if (+value === 0 || +target !== 0) {
    target = showType === 1 ? `${needShowEquelFlag ? '≈' : ''} ${target}` : target;
  } else {
    target = '< 0.01';
  }
  return (
    <span className={className}>
      <span className={amountClassName}>{target}</span>
      {!hideLegalCurrency && (
        <span style={{ marginLeft: 4 }} className={currencyClassName}>
          {currency}
        </span>
      )}
    </span>
  );
};
